module.exports = __webpack_public_path__ + "img/2f.998e7ac3.png";